import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CookbookFilterComponent } from './cookbook-filter.component';
import { RouterModule } from '@angular/router';
import { TreeModule } from 'primeng/primeng';
import { BlockUIModule } from 'primeng/blockui';
import { PanelModule } from 'primeng/panel';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    TreeModule,
    BlockUIModule,
    PanelModule
  ],
  declarations: [CookbookFilterComponent],
  exports: [
    CookbookFilterComponent
  ]
})
export class CookbookFilterModule { }



// WEBPACK FOOTER //
// ./src/app/cookbook-filter/cookbook-filter.module.ts